import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {
    getOperationEntitiesByGroupForDropDown,
    getCollectionCategoryByOperationEntityForDropDown,
    getCollectionPointsByOperationentityGroupID,
    getDairyCollectionDetailedReport,
    getCollectionPointsByCollectionCategory,
    getDailyCollectionDetailedReport
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getCollectionCategoryByOperationEntityForDropDown(id) {
    var collectionCategory = [];
    var response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', "operationEntityID=" + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true)
            collectionCategory[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"];
    }
    return collectionCategory;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getCollectionPointsByCollectionCategory(collectionCategoryID) {
    var collectionPointArray = [];

    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointsByCollectionCategory', 'collectionCategoryID=' + collectionCategoryID);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
    return collectionPointArray;
}

async function getDairyCollectionDetailedReport(collectionPointID,date) {
    var newModel = {
        collectionPointID: parseInt(collectionPointID),
        date: date,
        
    }
    const response = await CommonPost('/api/DairyCollectionDetailedReport/GetDairyCollectionDetailedReport', null, newModel);
    return response.data;
}

async function getDailyCollectionDetailedReport(data) {
  
    const response = await CommonPost('/api/LeafCollectionSummary/GetLeafSummaryReportData', null, data);
    return response.data;
}

